<app-banner-mobile></app-banner-mobile>
<div class="late-payment" *ngIf="hasLatePayment">
  <i class="material-icons">error</i> Você possui fee plataforma pendentes. Faça o pagamento para continuar fazendo ofertas.
  <button class="btn btn-white-outline btn-rounded text-white" (click)="onClickLinkSoldPayment()">VER PENDÊNCIAS</button>
</div>
<div class="main-header padding-left-lg-10 padding-right-lg-10 padding-left-lg-8 padding-right-lg-8 padding-left-0 padding-right-0">
  <div class="shopkeeper-header d-flex justify-content-between">
    <div class="menu-toggle" (click)="toggleSidebar()">
      <i class="material-icons">menu</i>
    </div>
    <div class="logo">
      <a [href]="routeToStart()">
        <img style="max-height: 32px; max-width: 200px" [src]="logoUrl ? logoUrl : './assets/images/logo-aar-horizontal-branco-ciano.png'" />
      </a>
    </div>
    <div class="header-part-center" [ngClass]="{ show: childnavOpen }">
      <div class="row">
        <div class="col p-3">
          <div class="menu-toggle" (click)="toggleSidebar()">
            <i class="material-icons">arrow_back</i>
          </div>
        </div>
      </div>
      <ng-container *ngIf="hasPermissionMenuAvaliador()">
        <div
          class="py-1 d-inline-block item-menu"
          [autoClose]="activeMenu !== 'CAPTAR' && 'outside'"
          [open]="activeMenu === 'CAPTAR'"
          routerLinkActive="active"
          ngbDropdown
        >
          <span ngbDropdownToggle (click)="onClickMenu('CAPTAR')">
            <a class="personalization-color">COMPRA</a>
          </span>
          <div ngbDropdownMenu class="submenu-dropdown">
            <a
              *ngIf="hasPermissionCaptar()"
              class="dropdown-item"
              [routerLink]="['/captar/veiculos']"
              (click)="toggleSidebar()"
              routerLinkActive="active"
            >
              <i class="app-icon-board"></i>
              CAPTAR
            </a>
            <a
              *ngIf="hasPermissionAvaliarHistory()"
              class="dropdown-item"
              [routerLink]="['/captar/historico']"
              (click)="toggleSidebar()"
              routerLinkActive="active"
            >
              <i class="app-icon-calendar"></i>
              HISTÓRICO
            </a>
            <a *ngIf="hasPermissionEvalLeads()" class="dropdown-item" [routerLink]="['/captar/leads']" (click)="toggleSidebar()" routerLinkActive="active">
              <i class="app-icon-layers"></i>
              LEADS
            </a>
            <a *ngIf="hasPermissionViewRescues()" class="dropdown-item" [routerLink]="['/captar/resgate']" (click)="toggleSidebar()" routerLinkActive="active">
              <i class="fa-solid fa-handshake"></i>
              RESGATE
            </a>
            <a
              *ngIf="hasPermissionRepasseImportEvaluations()"
              class="dropdown-item"
              [routerLink]="['/captar/importar']"
              (click)="toggleSidebar()"
              routerLinkActive="active"
            >
              <i class="material-icons">file_upload</i>
              IMPORTAR AVALIAÇÕES
            </a>
            <a *ngIf="hasPermissionEvalDashboard()" style="cursor: pointer" class="dropdown-item" routerLink="/captar/dashboards" routerLinkActive="active">
              <div>
                <i class="material-icons">space_dashboard</i>
                DASHBOARD
              </div>
            </a>
            <a style="cursor: pointer; margin-right: 15px" class="dropdown-item search-by-plate" routerLinkActive="active">
              <input matInput placeholder="Busca pela placa" [(ngModel)]="numberPlate" (keydown.enter)="getNumberPlate()" />
              <mat-icon matSuffix class="cursor-pointer" (click)="getNumberPlate()">search</mat-icon>
            </a>
            <a
              class="dropdown-item"
              (click)="navigateToOemDealerAdmin('buy')"
              routerLinkActive="active"
              *ngIf="hasPermissionOemDealerManager() && hasOemDealerSelected()"
            >
              <i class="material-icons">widgets</i>
              ADMIN
            </a>
          </div>
        </div>
        <div class="py-1 d-inline-block item-menu separador" *ngIf="hasPermissionMenuArremate()"></div>
      </ng-container>

      <ng-container *ngIf="hasPermissionMenuVender()">
        <div class="py-1 d-inline-block item-menu" [autoClose]="activeMenu !== 'VENDER'" [open]="activeMenu === 'VENDER'" ngbDropdown>
          <span (click)="onClickMenu('VENDER')" ngbDropdownToggle>
            <a class="personalization-color">Venda</a>
          </span>
          <div ngbDropdownMenu class="submenu-dropdown submenu-dropdown--compact">
            @if (hasPermissionTransferVehicles()) {
            <a class="dropdown-item" [routerLink]="['/vender/veiculos']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
              <i class="admin-icon-balao-dolar"></i>
              SUAS NEGOCIAÇÕES
            </a>
            }
            <a
              class="dropdown-item"
              [routerLink]="['/vender/leads']"
              (click)="toggleSidebar()"
              routerLinkActive="active"
              *ngIf="hasOemDealerSelected() && hasOemDealerWithLeads() && hasPermissionToViewLeads()"
            >
              <div>
                <i class="material-icons">forward_to_inbox</i>
                LEADS
              </div>
            </a>
            <a
              *ngIf="hasPermissionRepasse()"
              class="dropdown-item"
              [routerLink]="['/vender/estoque']"
              (click)="navReload(); toggleSidebar()"
              routerLinkActive="active"
            >
              <i class="app-icon-in-stock"></i>
              EM ESTOQUE
            </a>
            <a *ngIf="hasPermissionToViewDeletedVehicles()" class="dropdown-item" [routerLink]="['/vender/excluidos']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
              <i class="material-icons">delete_sweep</i>
              EXCLUÍDOS
            </a>
            @if (hasPermissionImportVehicles()) {
            <a class="dropdown-item" [routerLink]="['/vender/importar']" (click)="toggleSidebar()" routerLinkActive="active">
                <i class="material-icons">file_upload</i>
                IMPORTAR VEÍCULOS
              </a>
            }
            <a class="dropdown-item" [routerLink]="['/vender/relatorios']" (click)="toggleSidebar()" routerLinkActive="active" *ngIf="hasPermissionToViewSellReports()">
              <i class="app-icon-graph"></i>
              RELATÓRIOS
            </a>
            <a
              class="dropdown-item"
              [routerLink]="['/dashboard/tradein']"
              (click)="toggleSidebar()"
              routerLinkActive="active"
              *ngIf="(hasPermissionOemDealerManager() || hasPermissionToViewTradeinDashboard()) && hasOemDealerSelected()"
            >
              <div>
                <i class="material-icons">space_dashboard</i>
                DASHBOARD
              </div>
            </a>
            <a
              *ngIf="canSeeCancellationRequests()"
              class="dropdown-item"
              [routerLink]="['/vender/cancelar-venda']"
              (click)="toggleSidebar()"
              routerLinkActive="active"
            >
              <i class="fa-regular fa-circle-xmark" style="font-size: 16px;"></i>
              CANCELADOS
            </a>
            <a
              class="dropdown-item"
              (click)="navigateToOemDealerAdmin('sell')"
              routerLinkActive="active"
              *ngIf="hasPermissionOemDealerManager() && hasOemDealerSelected()"
            >
              <i class="material-icons">widgets</i>
              ADMIN
            </a>
          </div>
        </div>
        <div class="py-1 d-inline-block item-menu separador"></div>
      </ng-container>
      <ng-container *ngIf="hasPermissionMenuArremate()">
        <div
          class="py-1 d-inline-block item-menu"
          [autoClose]="activeMenu !== 'ARREMATAR'"
          [open]="activeMenu === 'ARREMATAR'"
          routerLinkActive="active"
          ngbDropdown
        >
          <span ngbDropdownToggle (click)="onClickMenu('ARREMATAR')">
            <a class="personalization-color">
              {{ layoutVars?.marketplaceMenuLabel ? layoutVars.marketplaceMenuLabel : "EXCHANGE" }}
            </a>
          </span>
          <div ngbDropdownMenu class="submenu-dropdown">
            <a class="dropdown-item" [routerLink]="['/arrematar/veiculos']" (click)="navReload(); routeToStart(); toggleSidebar()" routerLinkActive="active">
              <i class="app-icon-car-alt"></i>
              VEÍCULOS
            </a>
            <a class="dropdown-item" [routerLink]="['/arrematar/repasse']" (click)="navReload(); routeToStart(); toggleSidebar()" routerLinkActive="active">
              <i class="app-icon-car"></i>
              REPASSE
            </a>
            <a class="dropdown-item" [routerLink]="['/cotacao-rapida/veiculos']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
              <i class="app-icon-fast-lightning"></i>
              COTAÇÃO RÁPIDA
              <div class="counter" *ngIf="fastQuoteCount > 0">
                {{ fastQuoteCount }}
              </div>
            </a>
            <ng-container *ngIf="hasPermissionMenuVehicle()">
              <a class="dropdown-item" [routerLink]="['/arrematar/seguindo']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
                <i class="app-icon-love"></i>
                SEGUINDO
              </a>
              <a class="dropdown-item" [routerLink]="['/arrematar/suas-ofertas']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
                <i class="app-icon-tag"></i>
                SUAS OFERTAS
              </a>
              <a class="dropdown-item" [routerLink]="['/arrematar/arrematados']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
                <i class="admin-icon-balao-dolar"></i>
                COMPRADOS
              </a>
              <a class="dropdown-item" [routerLink]="['/arrematar/buscas']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
                <i class="material-icons">search</i>
                BUSCAS SALVAS
              </a>
              <a class="dropdown-item" [routerLink]="['/arrematar/cancelados']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
                <i class="fa-regular fa-circle-xmark" style="font-size: 16px;"></i>
                CANCELADOS
              </a>
            </ng-container>
          </div>
        </div>

        <div class="py-1 d-inline-block item-menu separador"></div>
      </ng-container>

      <!--
      <div class="py-1 d-inline-block item-menu">
        <span>
          <a
            href="https://www.autoarremate.com.br/quem-somos/"
            (click)="toggleSidebar()"
            target="_blank"
            >Sobre</a
          >
        </span>
      </div>

      <div class="py-1 d-inline-block item-menu">
        <a
          href="https://www.autoarremate.com.br/entre-em-contato/"
          (click)="toggleSidebar()"
          target="_blank"
          >Contato</a
        >
      </div>
      <div class="py-1 d-inline-block item-menu separador"></div>-->
      <div
        class="py-1 d-inline-block item-menu"
        [autoClose]="activeMenu !== 'ADMINISTRACAO'"
        [open]="activeMenu === 'ADMINISTRACAO'"
        routerLinkActive="active"
        ngbDropdown
      >
        <span ngbDropdownToggle *ngIf="showAdminMenuTab()" (click)="onClickMenu('ADMINISTRACAO')">
          <a class="personalization-color">ADMIN</a>
        </span>
        <div ngbDropdownMenu class="submenu-dropdown submenu-dropdown--admin">
          <a *ngIf="canSeeDealersAdmin()" class="dropdown-item" [routerLink]="['/admin/dealer']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
            <i class="admin-icon-new-arramatar"></i>
            COMPRADORES
          </a>

          <a
            *ngIf="canSeeOemDealersMenu()"
            class="dropdown-item"
            [routerLink]="vendedoresAdminLink()"
            [queryParams]="vendedoresAdminQueryParams()"
            (click)="navigateToVendedoresAdmin($event)"
            routerLinkActive="active"
          >
            <i class="admin-icon-predio"></i>
            VENDEDORES
          </a>

          <a *ngIf="canSeeDealerProspectsAdmin()" class="dropdown-item" [routerLink]="['/admin/dealer-prospect']" (click)="navReload(); toggleSidebar()" routerLinkActive="active">
            <i class="fa-regular fa-user-plus"></i>
            PROSPECÇÃO
          </a>

          <a *ngIf="canSeeBankslipsAdmin()" class="dropdown-item" [routerLink]="['/admin/boletos']" (click)="toggleSidebar()" routerLinkActive="active">
            <div style="display: flex; align-items: flex-end">
              <i class="admin-icon-boleto" style="margin-top: -4px"></i>
              BOLETOS
            </div>
          </a>

          <a
            *ngIf="canSeeCancellationRefundsAdmin()"
            class="dropdown-item"
            [routerLink]="['/admin/cancellation-refunds']"
            (click)="toggleSidebar()"
            routerLinkActive="active"
          >
            <div>
              <i class="fa-solid fa-rotate-left"></i>
              REEMBOLSOS
              <div class="counter" *ngIf="requestedAuctionRefundsCount > 0">
                {{ requestedAuctionRefundsCount }}
              </div>
            </div>
          </a>

          <a *ngIf="canSeeDashboardsAdmin()" class="dropdown-item" [routerLink]="['/admin/dashboards']" (click)="toggleSidebar()" routerLinkActive="active">
            <div>
              <i class="material-icons">space_dashboard</i>
              DASHBOARDS
            </div>
          </a>

          <a *ngIf="canSeeFipeAdmin()" class="dropdown-item" [routerLink]="['/admin/fipeFutura']" (click)="toggleSidebar()" routerLinkActive="active">
            <div>
              <i class="material-icons">sell</i>
              FIPE
            </div>
          </a>

          <a *ngIf="canSeeBannersAdmin()" class="dropdown-item" [routerLink]="['/admin/banner']" (click)="toggleSidebar()" routerLinkActive="active">
            <div>
              <i class="material-icons">photo_library</i>
              BANNERS
            </div>
          </a>
          <a
            *ngIf="canSeeHomeAdmin()"
            class="dropdown-item"
            [routerLink]="['/admin/home-management']"
            (click)="toggleSidebar()"
            routerLinkActive="active"
          >
            <div>
              <i class="fas fa-gear"></i>
              HOME
            </div>
          </a>
          <a
            *ngIf="canSeeSlugAdmin()"
            class="dropdown-item"
            [routerLink]="['/admin/slug-management']"
            (click)="toggleSidebar()"
            routerLinkActive="active"
          >
            <div>
              <i class="fa-light fa-link"></i>
              SLUG
            </div>
          </a>
          <a
            *ngIf="canSeeRegionalsAdmin()"
            class="dropdown-item"
            [routerLink]="['/admin/regionals']"
            (click)="toggleSidebar()"
            routerLinkActive="active"
          >
            <div>
              <i class="fa-solid fa-map-location-dot"></i>
              REGIONAIS
            </div>
          </a>

          <!--
          <a
            class="dropdown-item"
            [routerLink]="['/admin/dealer']"
            (click)="toggleSidebar()"
            routerLinkActive="active"
          >
            <i class="app-icon-board"></i>
            BOLETOS
          </a>

          
          <a
            class="dropdown-item"
            [routerLink]="['/admin/dealer']"
            (click)="toggleSidebar()"
            routerLinkActive="active"
          >
            <i class="app-icon-board"></i>
            ESTATÍSTICAS
          </a>-->
        </div>
      </div>
    </div>
    <div class="header-part-right ml-lg-auto">
      <ng-container *ngIf="userInfo$ | async as user">
        <app-header-account-dropdown
          [userInfo]="user"
          *ngIf="isAuthenticated$ | async"
        ></app-header-account-dropdown>
      </ng-container>
      <div *ngIf="!(isAuthenticated$ | async) && layoutVars?.transactional">
        <a
          class="inline-block item-menu"
          style="color: var(--menu-item-color-hover)"
          [routerLink]="['/login']"
          [queryParams]="{ returnUrl: returnUrl }"
        >
          ENTRAR
        </a>
      </div>
  </div>
</div>
